import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons'
import UrlApis from 'utils/api/urlApis'
import axios from 'utils/api/axios'
import AxiosUtils from 'utils/api/axiosUtils'
import MY_LS from 'utils/myLittleStorage'
import LocalStorage from 'utils/myLocalStorage'
import { Message, MessageSeverity } from 'constants/message'
import { Link, Menu, MenuDivider, MenuItem, Typography, MenuList, Inline } from '@airbus/components-react/components'
import LogoutIcon from '@mui/icons-material/Logout'
import SettingsIcon from '@mui/icons-material/Settings'
import { IconButton, MenuButton, Avatar } from '@airbus/components-react/components'
import MessageContext from 'context/MessageContext'
import AuthContext from 'context/AuthContext'
import LoadingContext from 'context/LoadingContext'

const ModalUserMenu = ({}) => {
  const { t } = useTranslation()
  const { userName, isConnected, handleDisconnect, handleOpenModalLogIn } = useContext(AuthContext)

  const { handleLoadInProgress } = useContext(LoadingContext)
  const { handleDisplayMessage } = useContext(MessageContext)

  const lang = LocalStorage.getOrDefault(LocalStorage.KEY_LANG, LocalStorage.VALUE_TYPE.STRING, 'fr')

  const savePreferences = async (prefsToSave) => {
    console.debug(
      '<' +
        t('saveUserPreferences') +
        '> :: called URL = ' +
        encodeURI(UrlApis.URL_COMMON_STORES_PUT + '?lang=' + lang),
    )
    const headerCompleted = await AxiosUtils.getHeader(AxiosUtils.HEADERS.HEADER_UPDATE)
    console.debug('Csrf-token reveived -> call URL for <' + t('saveUserPreferences') + '>!')
    axios
      .put(encodeURI(UrlApis.URL_COMMON_STORES_PUT + '?lang=' + lang), prefsToSave, {
        headers: headerCompleted,
        withCredentials: false,
      })
      .then((ret) => {
        handleDisplayMessage(
          new Message(
            MessageSeverity.SUCCESS,
            t('saveUserPreferences'),
            ret.data?.amasisCode,
            ret.data.description
              ? ret.data.description
              : ret.data.title
                ? ret.data.title
                : ret.data.message
                  ? ret.data.message
                  : ret.data.error,
          ),
        )
      })
      .catch((err) => {
        console.debug('ERR <' + t('saveUserPreferences') + '>: ' + err)
        handleDisplayMessage(
          new Message(
            MessageSeverity.ERROR,
            t('saveUserPreferences'),
            err.response.data?.amasisCode,
            err.response.data?.description
              ? err.response.data?.description
              : err.response.data.title
                ? err.response.data.title
                : err.response.data.message
                  ? err.response.data.message
                  : err.response.data.error,
          ),
        )

        // In case of retry, we need to request a new CSRF-token!
        MY_LS.clear()
      })
      .finally(() => {
        handleLoadInProgress(false)
      })
  }

  /**
   * Save user's preferences from the LocalStorage to the backend-DB.
   * Steps:
   * - get from localStorage all {key, value} whose key starts with "prefs"
   * - parse these couples and build a full object (usage of myLittleStorage::put)
   * - call Axios to PUT this object into DB
   */
  const handleSyncSettings = async () => {
    handleLoadInProgress(true)

    // Clear from myLittleStorage any prefs previously copied/stored there to start-up from fresh
    MY_LS.remove(LocalStorage.KEY_PREFS)

    for (const keyPref in localStorage) {
      if (keyPref.startsWith(LocalStorage.KEY_PREFS + LocalStorage.KEYS_SEPARATOR)) {
        MY_LS.put(keyPref.split(LocalStorage.KEYS_SEPARATOR), localStorage.getItem(keyPref))
      }
    }

    await savePreferences(MY_LS.getOrDefault([LocalStorage.KEY_PREFS], LocalStorage.VALUE_TYPE.OBJECT, ''))
  }

  const handleLogOut = async () => {
    try {
      console.debug('signing out: ' + UrlApis.URL_SPECIAL_SIGNOUT_POST)
      await axios.post(
        UrlApis.URL_SPECIAL_SIGNOUT_POST,
        {},
        {
          headers: await AxiosUtils.getHeader(AxiosUtils.HEADERS.HEADER_SIGN_IN_OUT),
          withCredentials: false,
        },
      )
      console.debug('signing out response received!')

      // Clear CSRF locally to force requesting a new-one when needed (SINGIN, SIGNOUT, POST, PUT, etc. operations)
      MY_LS.clear()

      handleDisplayMessage(new Message(MessageSeverity.INFO, t('8000395'), null, t('9500133')))
      //Notify parent of login successful
      handleDisconnect()
      return true
    } catch (err) {
      // In case of retry, we need to request a new CSRF-token!
      MY_LS.clear()

      handleDisplayMessage(
        new Message(
          MessageSeverity.ERROR,
          t('8000395'),
          err.response.data?.amasisCode,
          err.response.data?.description
            ? err.response.data?.description
            : err.response.data.title
              ? err.response.data.title
              : err.response.data.message
                ? err.response.data.message
                : err.response.data.error,
        ),
      )
      return false
    }
  }

  const performLogOut = async (e) => {
    e.preventDefault()

    // Perform log-out of the user with local storage clean-up
    await handleLogOut()
  }

  return (
    <div onClick={() => !isConnected && handleOpenModalLogIn()} style={{ cursor: 'pointer' }}>
      <Menu>
        <MenuButton disabled={!isConnected} component={IconButton} variant='ghost'>
          <Avatar status={isConnected ? 'available' : 'offline'} />
        </MenuButton>
        <MenuList>
          <MenuItem icon={<Avatar size='small' />}>
            <Inline>
              <Typography variant='small'>{userName}</Typography>
              {/*  <Link href='#' title={t('9500008')} size='small'>
                {t('9500008')}
              </Link>*/}
            </Inline>
          </MenuItem>
          <MenuDivider />
          {/*  <MenuItem icon={<SettingsIcon fontSize='small' />}>{t('8000144')}</MenuItem>*/}
          <MenuItem onClick={handleSyncSettings} icon={<FontAwesomeIcon icon={faCloudArrowUp} />}>
            {t('saveUserPreferences')}
          </MenuItem>
          <MenuItem onClick={performLogOut} icon={<LogoutIcon fontSize='small' />}>
            {t('8000395')}
          </MenuItem>
        </MenuList>
      </Menu>
    </div>
  )
}

export default ModalUserMenu
